import "swiper/css/bundle";
import '../css/main.css';

import './components/navigation'
import './components/navbarmobile'
import './components/dropdown'
// import './components/formbuilder'

import './pages/bussearchbar'
import './pages/leadershipDetails'
import './pages/gettingAround'
import './pages/doughnut'
import './pages/viewmorebutton'

import './components/trainsearchbar'
import './components/ImageSequencer'
import './components/accordion'


import './widgets/buttons'
import './widgets/swiper'

import { initAllWidget, initContext } from "./utils/init";

export const globalState = {}

document.addEventListener("DOMContentLoaded", () => {
    for (const [type, callback] of initContext.initialisers.entries()) {
        initAllWidget(type, callback)
    }
    // document.querySelectorAll("[widget-type]").forEach((widget) => {
    //     if (!widget.dataset.loaded) {
    //         console.warn("[Widget]", "Not Loaded", widget.getAttribute("widget-type"))
    //     }
    // })
})

if (__BUILD_DATE__) {
    const queries = new URLSearchParams(location.search)
    if (queries.has("version")) {
        console.log("[Build]", {
            // build_commit: __COMMIT_HASH__,
            build_date: __BUILD_DATE__
        })
    }
}

const getStoredTheme = () => window.localStorage.getItem('theme')
const setStoredTheme = theme => window.localStorage.setItem('theme', theme)

const getPreferredTheme = () => {
    const storedTheme = getStoredTheme()
    if (storedTheme) {
        return storedTheme
    }

    return 'light'
}

const setTheme = theme => {
    if (theme === 'contrast' && window.matchMedia('(prefers-color-scheme: contrast)').matches) {
        document.documentElement.setAttribute('data-bs-theme', 'contrast')
    } else {
        document.documentElement.setAttribute('data-bs-theme', theme)
    }
}

setTheme(getPreferredTheme())

document.getElementById('contrast-button')?.addEventListener('click', () => {
    if (document.documentElement.getAttribute('data-bs-theme') == 'contrast') {
        const theme = 'light';
        setStoredTheme(theme)
        setTheme(theme)
        document.documentElement.setAttribute('data-bs-theme', 'light')
    }
    else {
        const theme = 'contrast';
        setStoredTheme(theme)
        setTheme(theme)
        document.documentElement.setAttribute('data-bs-theme', 'contrast')

    }
})

function increaseFontSize(element) {
    console.log("element:", element)

    var originalSize = element.getAttribute("data-orgFontSize");
    const currentSize = window.getComputedStyle(element, null).getPropertyValue('font-size');
    console.log("currentSize:", currentSize)
    if (!originalSize) {
        originalSize = currentSize;
        element.setAttribute("data-orgFontSize", currentSize);
    }

    if (originalSize) {
        const size = parseFloat(originalSize.replace("px", ""));
        element.style.fontSize = (size
            + 1) + "px";
        for (var i = 0; i < element.children.length; i++) {
            console.log("element.children:", element.children[i])
            increaseFontSize(element.children[i]);
        }
    }
}

function resetFontSize(element) {
    var originalSize = element.getAttribute("data-orgFontSize");
    element.style.fontSize = originalSize;
    for (var i = 0; i < element.children.length; i++) {
        console.log("element.children:", element.children[i])
        resetFontSize(element.children[i]);
    }
}

function decreaseFontSize(element) {
    var originalSize = element.getAttribute("data-orgFontSize");
    const currentSize = window.getComputedStyle(element, null).getPropertyValue('font-size');
    console.log("currentSize:", currentSize)
    if (!originalSize) {
        originalSize = currentSize;
        element.setAttribute("data-orgFontSize", currentSize);
    }

    if (originalSize) {
        const size = parseFloat(originalSize.replace("px", ""));
        element.style.fontSize = (size
            - 2) + "px";
        for (var i = 0; i < element.children.length; i++) {
            decreaseFontSize(element.children[i]);
        }
    }
}


document.getElementById('increase-text-button')?.addEventListener('click', () => {
    console.log("increase clicked..")
    const targeting = document.getElementById("page-inner")
    increaseFontSize(targeting);
})

document.getElementById('reset-text-button')?.addEventListener('click', () => {
    console.log("reset clicked..")
    const targeting = document.getElementById("page-inner")
    resetFontSize(targeting);
})

document.getElementById('decrease-text-button')?.addEventListener('click', () => {
    console.log("decrease clicked..")
    const targeting = document.getElementById("page-inner")
    decreaseFontSize(targeting);
})
